module.exports = __webpack_public_path__ + "img/kerry.40a1b25c.png";